import { Component, ChangeDetectionStrategy } from '@angular/core';
import { StaticTemplateService } from '../../../api/gen';
import { sentryLogger } from 'shared/core';

@Component({
  selector: 'app-static-template-overview',
  templateUrl: './static-template-overview.component.html',
  styleUrls: ['./static-template-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StaticTemplateOverviewComponent {
  constructor(private readonly staticTemplateService: StaticTemplateService) {
    this.staticTemplateService
      .internalStaticTemplateDistinctGet()
      .subscribe((result) => {
        sentryLogger.debug('Loaded static template distinct result', {
          distinctCount: Array.isArray(result) ? result.length : undefined,
          hasResult: result !== null && result !== undefined,
        });
      });
  }
}
